export default "{\n    \"emptyText\": \"Click to select a team member\",\n    \"placeholderText\": \"Search by name, email or username\"\n}\n"